import React from 'react';
import './style.scss';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import { Delete, Snack, SodaCan } from '../../../../components/atoms/icons';
import Modal from '../../../../components/organisms/modals';
import api from '../../../../components/api';

interface Props {
    id: string;
    isShow: boolean;
    // eslint-disable-next-line no-unused-vars
    renderTh: (data: string, style?:React.CSSProperties | undefined) => JSX.Element
    // eslint-disable-next-line no-unused-vars
    renderTd: (data: string, style?:React.CSSProperties | undefined) => JSX.Element
}

interface VendingMachine {
    id: number | null;
    deviceId: string;
    location: string;
    type: number | null;
    scheduleDate: string;
}

function RenderVMTable(props: Props) {
  const {
    renderTh, renderTd, id, isShow,
  } = props;
  const { data: scheduleData, refetch } = useQuery(
    ['getById', 'schedules', id],
    () => api.schedules.getById(id),
    {
      enabled: !!id && isShow,
    },
  );
  const vmList: VendingMachine[] = React.useMemo(() => {
    const resData = scheduleData?.data?.data;
    const result : VendingMachine[] = [];
    if (resData) {
      const schDate = resData.date;
      const clients = resData.clients.map((client) => client.vendingMachines.map((vm) => vm));
      for (let i = 0; i < clients.length; i += 1) {
        for (let j = 0; j < clients[i].length; j += 1) {
          result.push({
            id: clients[i][j].id,
            deviceId: clients[i][j].deviceId ?? '-',
            location: clients[i][j].location ?? '-',
            type: clients[i][j].type,
            scheduleDate: schDate,
          });
        }
      }
      return result;
    }
    return result;
  }, [scheduleData]);
  // console.log(vmList);

  const [resultDelete, setResultDelete] = React.useState<any | undefined>(undefined);

  const { isLoading: loadingDelete, mutate: removeVM } = useMutation(api.schedules.removeVMFromSchedule, {
    onMutate: (x) => console.log('onMutate', x),
    onSuccess: (res) => {
      console.log(res);
      alert('success');
      setResultDelete(res);
    },
    onError: (err) => {
      console.log('err', err);
      alert('error');
      setResultDelete(err);
    },
  });

  const handleDelete = (vmId:number) => {
    const vmIds = new Array(1);
    vmIds[0] = vmId;

    removeVM({
      id: Number(id),
      vmId: vmIds,
    });
  };

  const onAfterResult = async () => {
    await refetch();
    setResultDelete(undefined);
  };

  const renderButtonVM = (url: string, title: string) => (
    <Link
      to={url}
      className="text-black text-decoration-none fw-normal border border-1 rounded-pill border-color-primary px-3 color-primary"
    >
      {title}
    </Link>
  );

  return (
    <Table borderless>
      <thead>
        <tr>
          <th style={{ width: '20px', border: 0 }}>&nbsp;</th>
          {renderTh('MACHINE ID', { width: '15%', minWidth: '100px' })}
          {renderTh('LOCATION', { width: '15%', minWidth: '150px' })}
          {renderTh('SALES THIS MONTH', { width: '15%', minWidth: '150px' })}
          {renderTh('OVERALL SALES', { width: '15%', minWidth: '150px' })}
          {renderTh(' ', { width: '35%', minWidth: '350px' })}
          {renderTh('ACTION', { width: '5%', minWidth: '50px', textAlign: 'right' })}
          <th style={{ width: '20px', border: 0 }}>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        {vmList.map((vm, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <tr key={i} className="align-middle">
            <td>&nbsp;</td>
            <td>
              <div className="d-flex fw-normal">
                <div style={{ marginTop: '-1px', marginRight: '5px' }}>
                  {vm.type === 0 ? <SodaCan width={8} /> : <Snack width={10} />}
                </div>
                {vm.deviceId}
              </div>
            </td>
            {renderTd(vm.location)}
            {renderTd('-')}
            {renderTd('-')}
            <td style={{ minWidth: '350px' }}>
              <div className="d-flex justify-content-evenly">
                {renderButtonVM('/routes/schedule', 'VM Service')}
                {renderButtonVM(`/routes/schedule/vm/re-stocking/${vm.id}?type=${vm.type}&scheduleDate=${vm.scheduleDate}&scheduleId=${id}`, 'Re-stocking')}
                {renderButtonVM(`/vending-machine/planogram/${vm.id}`, 'Planogram')}
              </div>
            </td>
            <td>
              <div className="d-flex justify-content-end">
                <Modal.Default
                  cancelLabel="No"
                  submitLabel="Yes"
                  title="Remove VendingMachine"
                  body="Are you sure to remove this vending machine from schedule?"
                  dialogClassName="custom-modal-width"
                  size="sm"
                  isLoading={loadingDelete}
                  result={resultDelete}
                  onSubmit={() => handleDelete(vm.id!)}
                  onAfterResult={onAfterResult}
                >
                  <div style={{ marginBottom: '2px', marginRight: '30px' }}>
                    <Delete width={18} />
                  </div>
                </Modal.Default>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

export default RenderVMTable;
